import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from "environments/environment";
import { States } from "app/_models/states";
import { Cities } from "app/_models/cities";
import { CitiesWithStates } from "app/_models/cities-with-states";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class CommonservicesService {
  private readonly _baseUrl: string;

  constructor(private readonly http: HttpClient) {
    this._baseUrl = environment.baseUrl;
  }

  getUserProductCatSubcatCount() {
    let headers = new HttpHeaders({
      "x-api-version": "1.0",
    });
    let options = {
      headers: headers,
      withCredentials: true
    };
    return this.http.get<any>(
      this._baseUrl + "Common/GetUserProductCatSubcatCount" , options
    );
  }

  getPurchaseOrderDetailsForChart() {
    return this.http.get<any>(
      this._baseUrl + "Common/GetPurchaseOrderDetailsForChart"
    );
  }

  getStates() {
    return this.http.get<States[]>(this._baseUrl + "Common/GetStates");
  }
  getAllCitiesWithStateId(stateId: number) {
    return this.http.get<CitiesWithStates[]>(
      this._baseUrl + "Common/GetAllCitiesWithStateId?stateId" + stateId
    );
  }
  getAllCitiesWithState() {
    let headers = new HttpHeaders({
      "x-api-version": "1.0",
    });
    let options = {
      headers: headers,
      withCredentials: true
    };
    return this.http.get<CitiesWithStates[]>(
      this._baseUrl + "Common/GetAllCitieswithState", options
    );
  }
  getCities() {
    return this.http.get<States[]>(this._baseUrl + "Common/GetCities");
  }
  getCityByStateId(stateId: number) {
    return this.http.get<Cities[]>(
      this._baseUrl + "Common/GetCitiesByStateId?stateId=" + stateId
    );
  }

  getResultFileByFileName(fileName: string): any {
     
    const httpOptions = {
      responseType: "blob" as "json",
       headers:  new HttpHeaders({'x-api-version': '2.0'})
    };
    return this.http.get<any>(
      this._baseUrl + "Common/GetResultFileByFileName?fileName=" + fileName,
      httpOptions
    );
  }

  getInvSpecificBankDetails() {
    return this.http.get<any>(this._baseUrl + "Common/GetInvSpecificBanks");
  }

  getResultFile(fileName: string) {
    let headers = new HttpHeaders({
      "x-api-version": "2.0",
    });

    let options = {
      headers: headers,
      withCredentials: true,
      responseType: "blob" as "json", // Type assertion needed for blob responses
    };

    return this.http.get<any>(
      this._baseUrl + "Common/GetResultFile?fileName=" + fileName,
      options
    );
  }

  addCity(model: any): Observable<any> {
    let headers = new HttpHeaders({
      'x-api-version': '2.0'
        });
  let options = { headers: headers,  withCredentials: true  };
     return this.http.post<any>(
      `${this._baseUrl}common/AddCity`, model, options
     );
  }

  deleteCity(model: any): Observable<any> {
    let headers = new HttpHeaders({
      'x-api-version': '2.0'
        });
  let options = { headers: headers,  withCredentials: true  };
     return this.http.post<any>(
      `${this._baseUrl}common/DeleteCity`, model, options
     );
  }

  updateCity(model: any): Observable<any> {
    let headers = new HttpHeaders({
      'x-api-version': '2.0'
        });
  let options = { headers: headers,  withCredentials: true  };
     return this.http.post<any>(
      `${this._baseUrl}common/UpdateCity`, model, options
     );
  }

  getSampleBulkCityFile(): any {
    let headers = new HttpHeaders({
      "x-api-version": "2.0",
    });

    let options = {
      headers: headers,
      withCredentials: true,
      responseType: "blob" as "json", // Type assertion needed for blob responses
    };

    return this.http.get(
      this._baseUrl + "common/GetSampleBulkCityFile",
      options
    );
  }

  
  uploadFileToBulkCreateCities(model: any): Observable<any> {
    let headers = new HttpHeaders({
      "x-api-version": "2.0",
    });

    let options = {
      headers: headers,
      withCredentials: true
    };

    return this.http.post<any>(
      this._baseUrl + "Common/UploadToBulkCreateCities",
      model, options
    );
  }


}
